import { VisitPrintsPatientSendCommand, VisitPrintsPatientSendResult } from '@dreryk/egabinet-visit-frontend-api';

import { useCqrsCommand } from '@dreryk/command-query-react-common';
import { ActionEventInterceptor } from '@dreryk/react-components';

import {
   MedicalDocumentationShareFormBean,
   MedicalDocumentationShareFormSubmitHandler,
} from '~libs.desktop.shared.medical-documentation';

import { recommendationsTranslationKeys } from '../../../../translations';

type RecommendationsPrintsPatientSendActionEventInterceptorRenderProps = { filePassword: string | null };

type RecommendationsPrintsPatientSendActionEventInterceptorProps = Readonly<{
   children: (renderProps: RecommendationsPrintsPatientSendActionEventInterceptorRenderProps) => JSX.Element;
   visitId: number;
   onMedicalDocumentationShareFormSubmit: MedicalDocumentationShareFormSubmitHandler;
}>;

export const RecommendationsPrintsPatientSendActionEventInterceptor = (
   props: RecommendationsPrintsPatientSendActionEventInterceptorProps
): JSX.Element => {
   const { executeAsync: sendPatientPrints, data } = useCqrsCommand<
      VisitPrintsPatientSendResult,
      MedicalDocumentationShareFormBean
   >((parameters) => {
      const command = new VisitPrintsPatientSendCommand();
      command.visitId = props.visitId;
      command.prints = {
         otherDocuments: false,
         physicalExamination: false,
         recommendations: true,
         summary: false,
      };
      command.contact = {
         phoneNumber: parameters.phoneNumber!,
         emailAddress: parameters.emailAddress!,
      };

      return command;
   });

   return (
      <ActionEventInterceptor
         action={props.onMedicalDocumentationShareFormSubmit(sendPatientPrints)}
         blockingOperation={recommendationsTranslationKeys.actions.sharingPrint}
      >
         {props.children({ filePassword: data?.password ?? null })}
      </ActionEventInterceptor>
   );
};
